import React from 'react'
import { Form, Formik } from 'formik'
import { Link } from 'react-router-dom'
import PasswordFieldC from 'components/FormFieldControl/PasswordFieldC'
import FormFieldControl from 'components/FormFieldControl'
import { userLoginSchema } from 'pages/Login/schema'
import { getItem } from 'utils/storageUtils'
import { UserRegisterButton } from 'components/Buttons'
import useUserLogin from 'pages/Login/useUserLogin'
import { AUTH_MODAL_TABS } from 'constants/general'

const LoginModalForm = ({ setAuthTab }) => {
  const {
    loading,
    // showModal,
    showResendEmail,
    languageData,
    // language,
    // setLanguage,
    // setShowModal,
    // isUserBlock,
    handleSignIn
  } = useUserLogin()

  return (
    <section className='login-signup-modal'>
      <Formik
        enableReinitialize
        initialValues={{ email: '', password: '' }}
        validationSchema={userLoginSchema(languageData)}
        onSubmit={({ email, password }) => handleSignIn({ email, password })}
      >
        {(formik) => {
          return (
            <Form className='auth-form-modal'>
              <FormFieldControl
                type='text'
                name='email'
                control='input'
                label='loginEmail'
                extraLabel='loginUsername'
                placeholder={languageData?.emailPlaceholder}
                containerClassName='custom-form-group'
                fieldClassName='form-control custom-input'
                showLabel={false}
                autoComplete='username'
                spellCheck='false'
              />

              <PasswordFieldC
                formik={formik}
                name='password'
                label='loginPassword'
                placeholder={languageData?.passwordPlaceholder}
                fieldClassName='form-control custom-input'
                isAccountInfo={false}
                containerClassName='custom-form-group'
                showLabel={false}
                autoComplete='current-password'
              />

              <UserRegisterButton
                formik={formik}
                loading={loading}
                spinner
                text={`${languageData?.loginFormButton || 'Log In'}`}
                className='btn-hover-effect login-btn'
                disabled={loading}
                disabledClassName='' // defalut disabled class removed
              />

            </Form>
          )
        }}
      </Formik>
      <div className='forget-link-btn'>
        {showResendEmail && (
          <Link
            to={`/${getItem(
              'language'
            )?.toLowerCase()}/resend-email`}
          >
            {languageData?.resendEmail}
          </Link>
        )}
        <p onClick={() => setAuthTab(AUTH_MODAL_TABS.FORGOT_PASSWORD)}>
          {languageData?.forgetPassword}?
        </p>
      </div>
    </section>
  )
}

export default LoginModalForm
